export const AppRoutes = {
  // Home
  home: "/",

  // Login
  login: "/login",
  logout: "/logout",
  recover: "/recover",
  recoverComplete: "/recover-complete",
  resetPassword: "/reset-password",
  resetPasswordComplete: "/reset-password-complete",
  register: "/register",
  registerComplete: "/register-complete",
  confirmEmail: "/user-setting/confirm-email",

  // Information
  information: "/information",
  informationDetail: "/information/:id",

  // User Setting
  userSettingDetail: "/user-setting/detail",
  userSettingEdit: "/user-setting/edit",
  userSettingChangeEmail: "/user-setting/change-email",

  // company
  companyList: "/companies",
  companyCreate: "/company/create",
  companyDetail: "/company/:companyId/detail",
  companyEdit: "/company/:companyId/edit",
  companyImport: "/companies/import",
  companyUserCreate: "/company/:companyId/user/create",
  companyUserEdit: "/company/:companyId/user/:userId/edit",

  // Talent
  talentList: "/talent",
  talentCreate: "/talent/create",
  talentDetail: "/talent/:talentId/detail",
  talentEdit: "/talent/:talentId/edit",
  talentImport: "/talent/import",

  // Job
  jobList: "/job",
  jobCreate: "/job/create",
  jobDetail: "/job/:jobId/detail",
  jobEdit: "/job/:jobId/edit",

  // Case
  caseList: "/cases",
  caseCreate: "/job/:jobId/case/create",
  caseDetail: "/job/:jobId/case/:caseId/detail",
  caseEdit: "/job/:jobId/case/:caseId/edit",

  // page not found
  pageNotFound: "/page-not-found",
  serverErrorPage: "/server-error",

  // Maintenance
  maintenance: "/maintenance",

  // Match
  match: "/match",
  matchEdit: "/match/edit",

  // Exam Steps
  examSteps: "/exam-steps",
  examStepDetail: "/exam-steps/:industryId",

  // Learning Progress
  learningProgress: "/learning-progress",
  learningProgressDetail: "/learning-progress/:industryId",
  learningProgressLearnerDetail: "/learning-progress/:industryId/learner/:learnerId",
  learningProgressLearnerEdit: "/learning-progress/:industryId/learner/:learnerId/edit",
  learningProgressReport: "/learning-progress/:industryId/progress-report",
  learningProgressReportCompany: "/learning-progress/:industryId/progress-report/company/:companyId",

  // Learner
  learnerList: "/learners",
  learnerCreate: "/learner/create",
  learnerBulkImport: "/learner/bulk-import",
  learnerBulkImportComplete: "/learner/bulk-import/complete",
  learnerDetail: "/learner/:learnerId/detail",
  learnerEdit: "/learner/:learnerId/edit",
  learnerPlanList: "/learner/:learnerId/plans",

  // RSO
  rsoDetail: "/rso/detail",
  rsoEdit: "/rso/edit",
};

export const LoginRoutes = [AppRoutes.login, AppRoutes.recover, AppRoutes.resetPassword, AppRoutes.register, AppRoutes.confirmEmail];

export const TalentRoutes = [AppRoutes.talentList, AppRoutes.talentCreate, AppRoutes.talentDetail, AppRoutes.talentEdit, AppRoutes.talentImport];

export const CompanyRoutes = [AppRoutes.companyList, AppRoutes.companyCreate, AppRoutes.companyDetail, AppRoutes.companyEdit, AppRoutes.companyUserCreate, AppRoutes.companyUserEdit];

export const UserSettingRoutes = [AppRoutes.userSettingDetail, AppRoutes.userSettingEdit, AppRoutes.userSettingChangeEmail];

export const ClientRoutes = [AppRoutes.home, AppRoutes.talentList].flat();

export const MatchRoutes = [AppRoutes.match];

export const JobRoutes = [AppRoutes.jobList, AppRoutes.jobCreate, AppRoutes.jobEdit, AppRoutes.jobDetail];

export const CasesRoutes = [AppRoutes.caseList, AppRoutes.caseCreate, AppRoutes.caseDetail, AppRoutes.caseEdit];

export const LearnerRoutes = [AppRoutes.learnerList, AppRoutes.learnerCreate, AppRoutes.learnerDetail, AppRoutes.learnerEdit, AppRoutes.learnerPlanList];

export const LearningRoutes = [
  AppRoutes.learningProgress,
  AppRoutes.learningProgressDetail,
  AppRoutes.learningProgressLearnerDetail,
  AppRoutes.learningProgressLearnerEdit,
  AppRoutes.learningProgressReport,
  AppRoutes.learningProgressReportCompany,
];

export const RsoRoutes = [AppRoutes.rsoDetail, AppRoutes.rsoEdit];

export const ExamRoutes = [AppRoutes.examSteps, AppRoutes.examStepDetail];